export default __webpack_public_path__ + "static/plan-532ef7b405ed48181912f9611ff427ce.png";